import {fromJS} from 'immutable';

import {ADD_AVATAR, ADD_AVATAR_BEGIN} from './actions';

export const initialState = fromJS({
  items: {},
  avatarsInFlight: {}
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_AVATAR:
    {
      const {id, avatar} = action.payload;

      return state.setIn(['items', id], avatar).deleteIn(['avatarsInFlight', id]);
    }
    case ADD_AVATAR_BEGIN:
      return state.setIn(['avatarsInFlight', action.payload.id], true);
    default:
      return state;
  }
}
